import 'core-js';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import ScrollToTop from 'HOC/ScrollToTop';
import Config from 'Config';

import 'fontawesome';
import 'i18n';

/*eslint-disable */
if (Config.upScope) {
  (function(w, u, d){var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};var l = function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://code.upscope.io/P4rKNyNy7J.js';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(typeof u!=="function"){w.Upscope=i;l();}})(window, window.Upscope, document); 
  Upscope('init');
}

/* eslint-enable */

// TODO Check if we can use BrowserRouter instead of HashRouter
ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop>
      <Route path="/" component={App} />
    </ScrollToTop>
  </BrowserRouter>,
  document.getElementById('app')
);

module.hot.accept();
